import { createClient } from '@supabase/supabase-js';
import { logger } from '../utils/logger';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Create a single, stable Supabase client instance
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'sb-auth-token',
    flowType: 'pkce',
    detectSessionInUrl: true,
    debug: import.meta.env.DEV,
  },
  global: {
    headers: {
      'X-Client-Info': 'pinnacle-home-theater',
    }
  },
  db: {
    schema: 'public'
  },
  realtime: {
    params: {
      eventsPerSecond: 2
    }
  }
});

// Test connection function for debugging
export async function testConnection(): Promise<boolean> {
  try {
    const { error } = await supabase
      .from('systems')
      .select('id')
      .limit(1);

    if (error) {
      logger.error('Supabase connection test failed:', error);
      return false;
    }
    
    return true;
  } catch (error) {
    logger.error('Supabase connection test error:', error);
    return false;
  }
}